import { map } from 'rxjs/operators';
import { OperatorFunction } from 'rxjs';

// todo: rename pluckKey
export function safePluck<T, K extends keyof T>(key: K): OperatorFunction<T, T[K]> {
  return map((input: T) => input[key]);
}
